<pms-container [load]="loadFn" (data)="onData($event)">
  <div *containerContent class="flex flex-1 flex-col">
    <div class="flex flex-row gap-4 bg-container p-2 pb-0">
      <div class="flex flex-col gap-1">
        <span class="uppercase text-xxs text-slate-400">{{
          "Nuovo" | transloco
        }}</span>

        <snt-button-icon
          [disabled]="!('create' | can: 'template')"
          icon="fa-light fa-file-circle-plus"
          [title]="'Crea modello' | transloco"
          (onClick)="onNew()"
        ></snt-button-icon>
      </div>
    </div>

    <div class="flex flex-1 bg-container p-2">
      <snt-table
        [showedColumns]="['name', 'public', 'actions']"
        [dataSource]="templates()"
      >
        <snt-table-column
          name="name"
          [caption]="'Nome' | transloco"
          [expand]="true"
        >
          <div
            *sntTemplate="let row = row"
            class="flex flex-row items-center justify-start gap-2"
          >
            <div class="flex">{{ row.name }}</div>
            @if (!row.published) {
              <div class="rounded-md bg-slate-100 px-2 py-0">
                <span class="text-xxs text-slate-600">{{
                  "BOZZA" | transloco
                }}</span>
              </div>
            }
          </div>
        </snt-table-column>

        <snt-table-column
          name="public"
          [caption]="'Pubblicato' | transloco"
          [alignCaption]="'center'"
          [width]="96"
        >
          <div
            *sntTemplate="let row = row"
            class="flex flex-1 flex-row items-center justify-center"
          >
            @if (row.published) {
              <i class="fa-light fa-check"></i>
            }
          </div>
        </snt-table-column>

        <snt-table-column
          name="actions"
          [caption]="''"
          [padding]="'1'"
          [width]="160"
        >
          <div
            *sntTemplate="let row = row"
            class="flex-1 flex justify-end gap-2"
          >
            <snt-button-icon
              icon="fa-light fa-eye"
              [title]="'Anteprima' | transloco"
              (onClickAsync)="onPreview($event, row)"
            ></snt-button-icon>

            <snt-button-icon
              icon="fa-light fa-copy"
              [title]="'Duplica' | transloco"
              (onClickAsync)="onDuplicate($event, row)"
            ></snt-button-icon>

            @if (!row.published) {
              <snt-button-icon
                icon="fa-light fa-pen"
                [title]="'Modifica' | transloco"
                (onClickAsync)="onEdit($event, row)"
              ></snt-button-icon>
            }

            @if (row.published) {
              <snt-button-icon
                icon="fa-light fa-pen"
                [title]="'Clona' | transloco"
                (onClickAsync)="onClone($event, row)"
              ></snt-button-icon>
            }

            <snt-button-icon
              icon="fa-light fa-trash"
              (onClick)="onDelete(row)"
            ></snt-button-icon>
          </div>
        </snt-table-column>
      </snt-table>
    </div>
  </div>
</pms-container>
